import yup from 'config/yup'

export default yup.object().shape({
  status: yup.number().required()
})
